import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {RESTRICTION_REASONS} from "./restrictions-constants";
import {DialogButtonClickHandleResultEnum} from "../../dialog/dialog.service.interface";
import DateFormatter from "../../../../sdk/src/utils/date_formatter";
import {NullableDate} from "../../../../common/types/nullable-types";

export class RestrictionMessages {
    constructor(private readonly reasonId: number,
                private readonly expirationDate: NullableDate,
                private readonly services: IServiceFactoryExtended,
                ) {
    }

    showUserMessage(): void {
        if(this.reasonId === RESTRICTION_REASONS.SESSION_LIMIT_REACHED) {
            this._showSessionLimitMessage()
        } else {
            this._showGenericMessage();
        }
    }

    private _formatDate(date: Date) {
        return  DateFormatter.format(date, this.services.time.getDateTimeFormat());
    }

    private _showSessionLimitMessage(): void {
        const translation = this.services.translation;

        this.services.dialog.showSimpleTextModal({
            title: translation.translate('GENERIC_NOTIFICATION_POPUP_TITLE'),
            text: translation.translate('GAMBLING_SESSION_SELF_RESTRICTION_MESSAGE', {
                restrictionExpirationDate: this._formatDate(this.expirationDate)
            }),
            buttons: [
                {
                    text: translation.translate('OK'),
                    buttonPreset: 'primary',
                    onClick: async () => {
                        this.services.analytics.sendOrbitUserFlowEvent(
                            'Client_SelfRestrictionError',
                            'CTA_1',
                            'OK');

                        return DialogButtonClickHandleResultEnum.CloseDialogAndContinue;
                    }
                }
            ]
        })
    }

    private _showGenericMessage(): void {
        const translation = this.services.translation;

        this.services.dialog.showSimpleTextModal({
            text: this.services.restrictions.getGenericRestrictionMessage(),
            title: '',
            showEmptyTitle: true,
            buttons: [
                {
                    text: translation.translate('OK'),
                    buttonPreset: 'primary',
                    onClick: async () => {
                        this.services.analytics.sendOrbitUserFlowEvent(
                            'Client_RestrictionError',
                            'CTA_1',
                            'OK');

                        return DialogButtonClickHandleResultEnum.CloseDialogAndContinue;
                    }
                }
            ]
        })
    }
}